module.exports = __webpack_public_path__ + "static/src/content/images/processed/1000/thurston_cover.36e5d60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/1000/thurston_cover.jpg
// module id = Z5b3
// module chunks = 1